<template>
    <li class="accordion-list-item-wrapper">
          <details class="accordion-list-item" >
            <summary class="accordion-list-item-title-wrapper">
              <h4 class="accordion-list-item-title">
                {{ title }}</h4>
              <span class="icon-wrapper" aria-hidden="true">
                <img class="chevron-icon" src="@/assets/images/icons/chevron-up.svg" alt="" >
              </span>
            </summary>
            <div class="accordion-item-content">
                <slot></slot>
            </div>
          </details>
        </li>
</template>
<script>
export default {
  name: 'AccordionListItem',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
